<template>
    <component
        :is="footerComponent"
        :has-footer-logo="!isEmpty(footerLogo)"
        :social-links="socialLinks"
        :entry="footer"
    >
        <template #logo>
            <NuxtLink v-if="footerLogo.length > 0" :to="homeUri">
                <img :src="footerLogo[0].url" :class="logoSize">
            </NuxtLink>
        </template>

        <template #siteByDigistorm>
            <NuxtLink to="http://www.digistorm.com.au" class="font-medium text-brand-extra-strong hover:underline underline-offset-2 text-sm" target="_blank">
                site by Digistorm
            </NuxtLink>
        </template>

        <template #copyright>
            <span class="font-medium text-brand-extra-strong text-sm">
                © {{currentYear}} {{siteDetails?.name}}
            </span>
        </template>
    </component>
</template>

<script setup>
    const { digistormSettings, getGlobalSetField, appId, homeUri, siteDetails } = storeToRefs(useGlobalStore())

    const footer = computed(() => {
        return first(getGlobalSetField.value('ds_Navigation_GlobalSet', 'footer') || [])
    })

    const footerType = computed(() => {
        return digistormSettings.value.footerType
    })

    // check for any custom components
    const customComponents = await import(`~/custom/${appId.value}/index.js`)
        .catch(() => {
            return null
        })

    const socialLinks = computed(() => {
        return getGlobalSetField.value('ds_Socials_GlobalSet', 'socials_SocialLinks')
    })

    const footerComponent = computed(() => {
        if (footerType.value === 'footer-custom') {
            return customComponents?.default?.Footer
        }

        return defineAsyncComponent(() =>
            import(`./${footerType.value}/footer.async.vue`)
        )
    })

    const footerLogo = computed(() => {
        return getGlobalSetField.value('ds_Logos_GlobalSet', 'logos_FooterLogo', true)
    })

    const logoSize = computed(() => {
        switch(getGlobalSetField.value('ds_Logos_GlobalSet', 'logos_FooterLogoSize', true)) {
            case 'sm':
                return 'max-h-18 max-w-48'
            case 'lg':
                return 'max-h-54 max-w-xl'
            case 'md':
            default:
                return 'max-h-36 max-w-96'
        }
    })

    const currentYear = computed(() => {
        return new Date().getFullYear()
    })
</script>

